import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./header.css";


import slide1Image from "../assets/img/slider/slide5.jpg";
//import slide2Image from "../assets/img/slider/slide2.jpg";
import slide3Image from "../assets/img/slider/maintenance3.jpeg";
import slide4Image from "../assets/img/slider/materiel.jpeg";

export const Header = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);


  const slides = [
    {
      bgImage: slide1Image,
      title: "Solutions Informatiques Innovantes",
      subtitle: "Pour votre entreprise",
      text: "Nos experts vous accompagnent dans la transformation numérique de votre entreprise avec des solutions sur mesure.",
      btnText: "Découvrir nos services",
      btnLink: "#services"
    },
    {
      bgImage: slide4Image,
      title: "Matériel Informatique de Qualité",
      subtitle: "Performance & Fiabilité",
      text: "TOGO 3000 vous propose une gamme complète d'équipements informatiques professionnels adaptés à vos besoins.",
      btnText: "Voir nos produits",
      btnLink: "products"
    },
    {
      bgImage: slide3Image,
      title: "Support Technique Dédié",
      subtitle: "À votre écoute",
      text: "Notre équipe technique vous assure un support réactif et personnalisé pour tous vos projets informatiques.",
      btnText: "Nous contacter",
      btnLink: "/contact"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 7000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Navigation manuel
  const goToSlide = (index) => setCurrentSlide(index);
  const nextSlide = () => setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length);

  return (
    <header id="header" className="togo-modern-header">
      <div className="togo-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`togo-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${slide.bgImage})`,
              backgroundColor: '#1a2f60'
            }}
          >
            <div className="togo-slide-overlay">
              <div className="togo-slide-content container">
                <div className="togo-slide-inner large-text">
                  <span className="togo-slide-subtitle">{slide.subtitle}</span>
                  <h1 className="togo-slide-title">{slide.title}</h1>
                  <p className="togo-slide-text">{slide.text}</p>
                  <div className="togo-slide-buttons">
                    {slide.btnLink.startsWith("/") ? (
                      <Link to={slide.btnLink} className="togo-btn-primary">
                        {slide.btnText}
                        <span className="togo-btn-arrow">→</span>
                      </Link>
                    ) : (
                      <a href={slide.btnLink} className="togo-btn-primary">
                        {slide.btnText}
                        <span className="togo-btn-arrow">→</span>
                      </a>
                    )}
                    <Link to="/a-propos" className="togo-btn-secondary">
                      En savoir plus
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Contrôles du slider */}
        <div className="togo-slider-controls">
          <button className="togo-slider-arrow togo-slider-prev" onClick={prevSlide}>
            <span className="togo-arrow-icon">←</span>
          </button>
          <div className="togo-slider-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`togo-slider-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Aller au slide ${index + 1}`}
              />
            ))}
          </div>
          <button className="togo-slider-arrow togo-slider-next" onClick={nextSlide}>
            <span className="togo-arrow-icon">→</span>
          </button>
        </div>

        {/* Indicateur de progression */}
        <div className="togo-progress-container">
          <div
            className="togo-progress-bar"
            style={{ width: `${(currentSlide + 1) * (100 / slides.length)}%` }}
          />
        </div>
      </div>
    </header>
  );
};